import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const getBrowseCatagoryAction = createAsyncThunk(
    'browse/catagory', async (reqBody, thunkAPI) => {
        try {
            let url = `school/content/list?search=${encodeURIComponent(reqBody?.searchValue || '')}`;

            if (reqBody?.categories) {
                const cats = Array.isArray(reqBody.categories)
                    ? reqBody.categories.filter(Boolean)
                    : typeof reqBody.categories === 'string'
                    ? reqBody.categories.split(',').map(c => c.trim()).filter(Boolean)
                    : [];

                if (cats.length === 1) {
                    url += `&categoryId=${encodeURIComponent(cats[0])}`;
                } else if (cats.length > 1) {
                    cats.forEach((id) => {
                        url += `&categoryId[]=${encodeURIComponent(id)}`;
                    });
                }
            }

            url += `&group=${encodeURIComponent(reqBody?.selectedGroup || '')}`;

            const response = await Api.get(url);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    })


    export const getBrowseSearchForDidYouMeanAction = createAsyncThunk(
        'getBrowseSearchForDidYouMeanAction/search', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.get(`school/content/mean?search=${reqBody?.searchValue}`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    

export const browseDetailAction = createAsyncThunk(
    'browse/details', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get(`school/content/details?id=${reqBody.id}&search=${reqBody?.searchValue}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })
export const browseAddToCollectionAction = createAsyncThunk(
    'browse/addToCollection', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.post('school/content/collection-add', reqBody)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })



    export const VideoviewAction = createAsyncThunk(
        'browse/View', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.post('school/content/view', reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    

export const browseCategoryDetailAction = createAsyncThunk(
    'browse/browseCatagory', async (reqBody, thunkAPI) => {
        try {
            let url = `school/content/category?search=${reqBody?.searchValue || ''}&videoId=${reqBody?.videoId || ''}`;
            if (reqBody.id) {
                url += `&id=${reqBody.id}`;
            }
            const response = await Api.get(url)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

    export const collectionVideosAction = createAsyncThunk(
        'collection/video', async (reqBody, thunkAPI) => {
            try {
    
                const response = await Api.get(`school/collection/videos?id=${reqBody.id}&search=${reqBody?.searchValue}&videoId=${reqBody?.videoId}`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    









            










export const browseCategoryDetailTestAction = createAsyncThunk(
    'browse/browseCatagorytest', async (reqBody, thunkAPI) => {
        try {

            const response = await Api.get(`school/content/test?categoryId=${reqBody.id}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })
    


export const browseCategoryDetailTestDetailAction = createAsyncThunk(
    'browse/browseCatagorytestDetail', async (reqBody, thunkAPI) => {
        try {

            const response = await Api.get(`school/content/test/details?id=${reqBody.id}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })
    

export const resetBrowseAction = createAction('browse/reset');

export const allCategoryList = createAsyncThunk(
    'school/category', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get(`school/category/list`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

export const getColorGroupListAction = createAsyncThunk(
    'school/colorGroupList', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get(`school/color-group/list`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    })

    export const likesCategoryList = createAsyncThunk(
        'school/likesCategory', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.get(`school/content/likedCategories`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })

export const getTailorFeedAction = createAsyncThunk(
    'school/getTailorFeed', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get('school/tailor-feed');
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateTailorFeedAction = createAsyncThunk(
    'school/updateTailorFeed', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.post('school/tailor-feed', reqBody);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const patchTailorFeedAction = createAsyncThunk(
    'school/patchTailorFeed', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.patch('school/tailor-feed', reqBody);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);